import { Component, OnInit, ViewChild } from '@angular/core';
import { PershingTranslationService, IAuthorizationService } from '@pershing/pershing-core';
import { BalancesService } from '../../services/balances.services';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { BalancesLabels } from '../../i18n/balances-labels';
import { BalancesResponse, Balances, BalancesSummary, BalancesDetails } from '../../model/index';
import { MatDialog } from '@angular/material/dialog';
import { TaxReclaimReceivablesComponent } from '../tax-reclaim-receivables/tax-reclaim-receivables.component';
@Component({
    selector: 'mobile-view-link',
    templateUrl: './mobile-view-link.component.html'
})

export class MobileViewSwitchComponent implements OnInit{
    isSummaryView: boolean = true;
    header: string = '';
    theme: string = 'standard';
    isLoading: boolean = true;
    balancesServiceErrorSub: any;
    balancesResponseSub: any;
    balancesResponseErrorSub: any;
    fetchingBalancesDataSub: any;
    balancesResponse: BalancesResponse;
    balancesData: Balances;
    balancesDataSummary: BalancesSummary;
    balancesDataDetails: BalancesDetails;
    isCustodian: boolean = false;
    totalAcctValue: any;
    asofTime: any;
    totalWorthDifference: any;
    totalWorthPercent: any;
    isMarginEnabled: boolean = true;
    disMarginEnabled: boolean = false;
    isGroup: boolean = false;
    isMixedGroup: boolean = false;
    BEMsg: string = 'BackEnd message Type [E|I] exists';
    SystemErrorMsg: string;
    entitledForWithdraw: boolean = true;
    dayTradingBuyingPowerEnable: boolean = true;
    entitledForLiabilities: boolean = false;
    entitledForTaxReclaimReceivables: boolean = false;
    liabilityData: any = [];
    showDelayedQuoteLegend: boolean = true;
    showDelayedQuoteLegendSub: any;
    defaultValue: any = 0;
    public sliderArray = new Array();
    withAnim: boolean = true;
    resetAnim: boolean = true;
    public carouselItems: any[];
    @ViewChild('myCarousel', { static: false }) myCarousel: NguCarousel;
    carouselConfig: NguCarouselConfig = {
        grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
        load: 3,
        point: {
            visible: true,
            hideOnSingleSlide: true
        },
        loop: true,
        touch: true,
        velocity: 0.2
    };
    isAllAccount: boolean = false;
    data: any;
    mortgagesData: any;
    loansData: any;
    displayToggle: boolean;
    displayContainer: string;
    showSummaryLine: boolean = true;

    constructor(
        private translationService: PershingTranslationService,
        private authorizationService: IAuthorizationService,
        private balancesService: BalancesService,
        private dialog: MatDialog ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');

    }

    ngOnInit(){
        if (this.balancesService.subsVar === undefined) {
            this.balancesService.subsVar = this.balancesService.
            displayToggleEmitter.subscribe((name: string) => {
            this.setDisplayToggle();
            });
        } 
        let roleStore = this.authorizationService['roleStore'] !== null;
        this.entitledForWithdraw = roleStore && this.authorizationService.isEntitled('HIDE_FUNDS_AVAIL_FOR_WITHDRAWAL') ?
            this.authorizationService.isEntitled('HIDE_FUNDS_AVAIL_FOR_WITHDRAWAL') : true;
        this.dayTradingBuyingPowerEnable = roleStore && this.authorizationService.isEntitled('DAY_TRADING_BUYING_POWER') ?
            this.authorizationService.isEntitled('DAY_TRADING_BUYING_POWER') : true;
        this.entitledForLiabilities = roleStore && this.authorizationService.isEntitled('LIABILITIES_BALANCE') ?
            this.authorizationService.isEntitled('LIABILITIES_BALANCE') : false;
        this.entitledForTaxReclaimReceivables = roleStore && this.authorizationService.isEntitled('VIEW_TAX_RECLAIM_RECEIVABLES') ?
            this.authorizationService.isEntitled('VIEW_TAX_RECLAIM_RECEIVABLES') : false;
        // Generic, http error e.g. 500.
        this.balancesServiceErrorSub = this.balancesService.balancesServiceError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
        });

        // Got BalancesResponse but has 'errorCode' of non-zero.
        this.balancesResponseErrorSub = this.balancesService.balancesResponseError$.subscribe(error => {
            this.SystemErrorMsg = !!error && !!error.errorMessage ? error.errorMessage : '';
            this.isLoading = false;
        });

        // loading
        this.fetchingBalancesDataSub = this.balancesService.fetchingBalancesData$.subscribe(fetching => {
            this.isLoading = !!fetching ? fetching : false;
        });

        this.balancesResponseSub = this.balancesService.balancesResponse$.subscribe(data => {
            if (!!data && !!data.response) {
                this.processBalancesData(data);
            }
        });

        this.showDelayedQuoteLegendSub = this.balancesService.realtimeQuote$.subscribe(realtime => {
            this.showDelayedQuoteLegend = !realtime;
        });
    }

    processBalancesData(data: BalancesResponse) {
        if (!!data && !!data.response) {
            this.balancesResponse = data;
            this.balancesData = data.response.balances;
            this.balancesDataSummary = data.response.balances.balancesSummary;
            this.balancesDataDetails = data.response.balances.balancesDetails;
            this.isGroup = this.balancesService.displayParams$.isGroup;
            this.isMixedGroup = this.balancesService.displayParams$.isMixedGroup;
            this.isCustodian = this.balancesService.displayParams$.isCustodian;
            this.isAllAccount = this.balancesService.getIfAllAccount();
            this.entitledForTaxReclaimReceivables = this.entitledForTaxReclaimReceivables && !this.isAllAccount;
            let bd = this.balancesDataDetails;
            let bs = this.balancesDataSummary;
            this.totalAcctValue = bs.totalWorth.value ? bs.totalWorth.value : this.defaultValue;
            let time = data.response.balances.asOfDate !=null ? data.response.balances.asOfDate.split('T')[1]:"";
            let timeSplitUp = time.split(':');
            let zone = parseInt(timeSplitUp[0]) >= 12 ?'PM':'AM';
            timeSplitUp[0] = parseInt(timeSplitUp[0]) > 12 ? (parseInt(timeSplitUp[0]) - 12) + '' : timeSplitUp[0];
            timeSplitUp[0] = parseInt(timeSplitUp[0]) == 0 ? '12' : timeSplitUp[0];
            this.asofTime = timeSplitUp[0] + ':' + timeSplitUp[1] + ' '+ zone + " EST";
            this.totalWorthDifference = bs.totalWorth.difference == null || bs.totalWorth.difference == undefined ? 0 : bs.totalWorth.difference;
            this.totalWorthPercent = bs.totalWorth.percentChange == null || bs.totalWorth.percentChange == undefined ? 0 : bs.totalWorth.percentChange;
            if (!this.isMixedGroup && this.isCustodian) {
                this.carouselItems = [
                    {
                        'key': 'BALANCES.MARKETVALUE',
                        'info': 'BALANCES.MARKETINFO',
                        'value': bs.totalWorth.value ? bs.totalWorth.value : this.defaultValue
                    },
                    {
                        'key': 'BALANCES.LONGMARKET',
                        'info': 'BALANCES.LONGMARKETINFO',
                        'value': bd.longMarketValue.value ? bd.longMarketValue.value : this.defaultValue
                    },
                    {
                        'key': 'BALANCES.CASH',
                        'info': 'BALANCES.CASHINFO',
                        'value': bd.cash.value ? bd.cash.value : this.defaultValue
                    },
                    {
                        'key': 'BALANCES.ANNUITIES',
                        'info': 'BALANCES.ANNUITIESINFO',
                        'value': bd.annuities.value ? bd.cash.value : this.defaultValue
                    }];
                if(this.entitledForTaxReclaimReceivables){
                    this.carouselItems.push(
                        {
                            'key': 'BALANCES.TAXRECLAIMRECEIVABLES',
                            'info': 'BALANCES.TAXRECLAIMRECEIVABLESINFO',
                            'value': bd.taxReclaim ? bd.taxReclaim : this.defaultValue
                        }
                    );
                }
            } else if(!this.isMixedGroup && !this.isCustodian){
               this.carouselItems = [
                {
                    'key': 'BALANCES.MARKETVALUE',
                    'info': 'BALANCES.MARKETINFO',
                    'value': bs.totalWorth.value ? bs.totalWorth.value : this.defaultValue
                },
                {
                    'key': 'BALANCES.AVAILABLETOTRADE',
                    'info': 'BALANCES.AVAILABLETOTRADEINFO',
                    'value': bs.fundsAvailableToTrade ? bs.fundsAvailableToTrade : this.defaultValue
                },
                {
                    'key': 'BALANCES.AVAILABLETOTRADEMARGIN',
                    'info': 'BALANCES.AVAILABLETOTRADEMARGININFO',
                    'value': bd.marginableEquity ? bd.marginableEquity : this.defaultValue
                },
                {
                    'key': 'BALANCES.BUYINGPOWER',
                    'info': 'BALANCES.BUYINGPOWERINFO',
                    'value': bd.dayTradingBuyingPowerPrevClose ? bd.dayTradingBuyingPowerPrevClose : this.defaultValue
                },
                {
                    'key': 'BALANCES.FUNDSDUE',
                    'info': 'BALANCES.FUNDSDUEINFO',
                    'value': bs.fundsDue ? bs.fundsDue : this.defaultValue
                }];

                if(this.entitledForWithdraw){
                    this.carouselItems.push(
                        {
                            'key': 'BALANCES.AVAILABLECASH',
                            'info': 'BALANCES.AVAILABLECASHINFO',
                            'value': bs.fundsAvailableToWithdraw ? bs.fundsAvailableToWithdraw : this.defaultValue
                        }
                    );
                }
            }
            if(this.entitledForLiabilities){
                this.carouselItems.push(
                    {
                        'key': 'BALANCES.LOANAMTOUTSTD',
                        'info': 'BALANCES.LOANAMTOUTSTDINFO',
                        'value': this.defaultValue
                    }
                );
                this.carouselItems.push(
                    {
                        'key': 'BALANCES.LOANAVALCASH',
                        'info': 'BALANCES.LOANAVALCASHINFO',
                        'value': this.defaultValue
                    }
                );
            }
            this.isLoading = false;
        }
    }

    clearBrokerageDisclaimers() {
        this.balancesService.updateDisclaimer({
            'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_FUNDSAVAILTOTRADE,
            'show': false, 'className': 'fundsAvailToTrade', 'showCounter': 0
        });
        this.balancesService.updateDisclaimer({
            'legendSymbol': '', 'legendByIndex': true, 'key': BalancesLabels.DISCLAIMER_CALCULATEDFUNDSDUE,
            'show': false, 'className': 'calculatedFundsDue', 'showCounter': 0
        });
    }

    reset() {
        this.myCarousel.reset(!this.resetAnim);
    }

    moveTo(slide) {
        this.myCarousel.moveTo(slide, !this.withAnim);
    }

    taxReclaimReceivablesPopup() {
        this.dialog.open(TaxReclaimReceivablesComponent, { disableClose: true, panelClass: ['modal', 'bal-TaxReclaimReceivablesDialog']});
    }

    setDisplayToggle(){
        this.showSummaryLine = this.balancesService.getDisplayToggle();
    }

    ngOnDestroy(): void {
        this.clearBrokerageDisclaimers();
        if (this.balancesServiceErrorSub) {
            this.balancesServiceErrorSub.unsubscribe();
        }
        if (this.balancesResponseErrorSub) {
            this.balancesResponseErrorSub.unsubscribe();
        }
        if (this.balancesResponseSub) {
            this.balancesResponseSub.unsubscribe();
        }
        if (this.fetchingBalancesDataSub) {
            this.fetchingBalancesDataSub.unsubscribe();
        }
        if (this.showDelayedQuoteLegendSub) {
            this.showDelayedQuoteLegendSub.unsubscribe();
        }
    }

}